export default function ShopProductCard({ product }) {
  const hasRating = Number(product.rating_count) > 0;

  const price = Number(product.price || 0);
  const finalPrice = Number(product.min_price || 0);

  const hasDiscount =
    Number(product.max_discount) > 0 &&
    finalPrice > 0 &&
    finalPrice < price;

  return (
    <article className="group flex h-full w-full flex-col overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm transition-all duration-200 hover:-translate-y-1 hover:border-gray-300 hover:shadow-lg sm:rounded-2xl">
      <div className="relative aspect-[4/3] overflow-hidden bg-gray-50 sm:aspect-square">
        {product.featured_image_url ? (
          <img
            src={product.featured_image_url}
            alt={product.name}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
          />
        ) : (
          <div className="flex h-full w-full items-center justify-center text-xs text-gray-400 sm:text-sm">
            بدون تصویر
          </div>
        )}

        {hasDiscount && (
          <span className="absolute right-1.5 top-1.5 rounded-full bg-[#E74C3C] px-1.5 py-0.5 text-[10px] font-medium text-white sm:right-2 sm:top-2 sm:px-2 sm:py-1 sm:text-[11px]">
            {product.max_discount}٪ تخفیف
          </span>
        )}

        {hasRating && (
          <span className="absolute left-1.5 top-1.5 inline-flex items-center gap-0.5 rounded-full bg-white/95 px-1.5 py-0.5 text-[10px] font-medium text-gray-700 shadow-sm sm:left-2 sm:top-2 sm:gap-1 sm:px-2 sm:py-1 sm:text-[11px]">
            <span className="text-[#FFC107]">★</span>
            <span>{Number(product.rating_avg || 0).toFixed(1)}</span>
          </span>
        )}
      </div>

      <div className="flex flex-1 flex-col p-2.5 sm:p-4">
        <h3 className="line-clamp-2 min-h-10 text-xs font-semibold leading-5 text-gray-900 sm:min-h-[48px] sm:text-[15px] sm:leading-6">
          {product.name}
        </h3>

        <div className="mt-1.5 flex min-h-5 items-center gap-1.5 sm:mb-2 sm:mt-2 sm:gap-2">
          {product.category_name && (
            <span className="inline-flex max-w-full items-center rounded-full bg-gray-100 px-1.5 py-0.5 text-[10px] font-medium text-gray-700 sm:px-2.5 sm:py-1 sm:text-[11px]">
              <span className="truncate">{product.category_name}</span>
            </span>
          )}

          {product.brand && (
            <span className="min-w-0 truncate text-[10px] text-gray-500 sm:text-xs">
              {product.brand}
            </span>
          )}
        </div>

        <div className="mt-auto pt-2.5 sm:pt-4">
          <div className="border-t border-gray-100 pt-2.5 sm:pt-3">
            {product.has_stock ? (
              <div className="flex flex-col items-end text-right">
                <div className="whitespace-nowrap text-xs font-semibold text-gray-900 sm:text-base">
                  {finalPrice.toLocaleString("fa-IR")}
                  <span className="mr-0.5 text-[10px] font-normal text-gray-500 sm:mr-1 sm:text-xs">
                    تومان
                  </span>
                </div>

                {hasDiscount && (
                  <div className="mt-0.5 text-[10px] text-gray-400 line-through decoration-gray-400 sm:text-xs">
                    {price.toLocaleString("fa-IR")}
                  </div>
                )}
              </div>
            ) : (
              <div className="flex flex-col items-end gap-1 sm:flex-row sm:items-center sm:justify-between">
                <span className="text-[10px] text-gray-400 sm:text-xs">
                  وضعیت موجودی
                </span>

                <span className="rounded-full bg-red-100 px-1.5 py-0.5 text-[10px] font-medium text-red-600 sm:px-2.5 sm:py-1 sm:text-xs">
                  ناموجود
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </article>
  );
}
